import ipaddr from 'ipaddr.js';
import { sortBy } from 'lodash';

import { parseIpInput } from '@/utils/Common.utils';

export const sortEnvironments = (environments: string[]) => {
  return sortBy(environments, (ip) =>
    ip
      .split('.')
      .map((num) => `${num}`.padStart(3, '0'))
      .join('')
  );
};

// Helper function to validate both IPv4 and IPv6
export function isValidIP(ip: string): boolean {
  // CIDR notation
  if (ip.includes('/')) {
    try {
      ipaddr.parseCIDR(ip);
      return true;
    } catch (_e) {
      return false;
    }
  }

  // Plain IP address
  if (ipaddr.isValid(ip)) {
    return true;
  }

  return false;
}

export const validatedEnvironments = (
  value: string,
  currentEnvironments: string[] = []
) => {
  const validIPs: string[] = [];
  const invalidIPs: string[] = [];
  const environmentsArray = parseIpInput(value);

  environmentsArray.forEach((item) => {
    if (validIPs.includes(item) || currentEnvironments?.includes(item)) {
      return;
    }

    const [startIp, endIp] = item.includes('-')
      ? item.split('-').map((ip) => ip.trim())
      : [item];

    if (!isValidIP(startIp) || (endIp && !isValidIP(endIp))) {
      invalidIPs.push(item);
    } else {
      validIPs.push(item);
    }
  });

  return { validIPs, invalidIPs };
};
